import { Navigate, RouteObject } from 'react-router-dom'
import { DayView } from '$features/calendar/components/calendar/views/day'
import { WeekView } from '$features/calendar/components/calendar/views/week'
import { CreateAppointmentModal } from '$features/calendar/pages/create'
import { ViewModal } from '$features/calendar/pages/view'
import { CalendarPage } from '$features/calendar/pages/calendar'

export enum CalendarRoutePaths {
  Calendar = '/calendar',
  CalendarView = ':id',
  CalendarCreate = 'create',
  CalendarDay = 'day',
  CalendarWeek = 'week',
}

const calendarModalRoutes: RouteObject[] = [
  {
    path: CalendarRoutePaths.CalendarCreate,
    element: <CreateAppointmentModal />,
  },
  {
    path: CalendarRoutePaths.CalendarView,
    element: <ViewModal />,
  },
]

export const protectedCalendarRoutes: RouteObject[] = [
  {
    path: CalendarRoutePaths.Calendar,
    element: <CalendarPage />,
    children: [
      {
        index: true,
        element: <Navigate
          to={CalendarRoutePaths.CalendarWeek}
          replace
        />,
      },
      {
        path: CalendarRoutePaths.CalendarDay,
        element: <DayView />,
        children: [
          ...calendarModalRoutes,
        ],
      },
      {
        path: CalendarRoutePaths.CalendarWeek,
        element: <WeekView />,
        children: [
          ...calendarModalRoutes,
        ],
      },
    ],
  },
]
